"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestDisplayToJSON = exports.QuestDisplayFromJSONTyped = exports.QuestDisplayFromJSON = exports.QuestDisplay = void 0;
/**
 *
 * @export
 * @enum {string}
 */
var QuestDisplay;
(function (QuestDisplay) {
    QuestDisplay["GAMES"] = "GAMES";
    QuestDisplay["CHALLENGES"] = "CHALLENGES";
    QuestDisplay["GUILDS"] = "GUILDS";
    QuestDisplay["LEADERBOARDS"] = "LEADERBOARDS";
})(QuestDisplay = exports.QuestDisplay || (exports.QuestDisplay = {}));
function QuestDisplayFromJSON(json) {
    return QuestDisplayFromJSONTyped(json, false);
}
exports.QuestDisplayFromJSON = QuestDisplayFromJSON;
function QuestDisplayFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.QuestDisplayFromJSONTyped = QuestDisplayFromJSONTyped;
function QuestDisplayToJSON(value) {
    return value;
}
exports.QuestDisplayToJSON = QuestDisplayToJSON;
